import type { Module } from "src/system/module.types.ts";

export const getModule = (resource: string): Module => {
  const modules = import.meta.glob<
    true,
    any,
    {
      module: Module;
    }
  >("../admin/modules/**/module.tsx", {
    eager: true,
  });
  const module = modules[`../admin/modules/${resource}/module.tsx`];
  if (!module) {
    throw new Error(`module for [${resource}] resource not found `);
  }
  return module.module;
};
